export default __webpack_public_path__ + "static/21-100-e37d9351ec67362aa7286debdb004ef8.jpg";